<script>
  import session from '../../../lib/session';
  import { init_zendesk } from '../../../lib/zendesk.js';

  export let label = 'Support';

  let support_button;

  const load_zendesk_chat = () => {
    console.log('Loading ZenDesk...');
    init_zendesk({ user: $session.user });

    let waiting = setInterval(() => {
      let launcher_frame = document.getElementById('launcher');

      if (launcher_frame) {
        clearInterval(waiting);
        support_button.style.display = 'none';
        let launcher_button = launcher_frame.contentWindow.document.querySelector(
          'button'
        );
        launcher_button.click();
      }
    }, 300);
  };
</script>

<div id="zendesk_support">
  <button
    class="btn"
    on:click|preventDefault|stopPropagation={load_zendesk_chat}
    bind:this={support_button}>
    <span class="container">
      <svg
        class="icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        aria-hidden="true">
        <g id="Layer_4">
          <path
            d="M11,12.3V13c0,0-1.8,0-2,0v-0.6c0-0.6,0.1-1.4,0.8-2.1c0.7-0.7,1.6-1.2,1.6-2.1c0-0.9-0.7-1.4-1.4-1.4
            c-1.3,0-1.4,1.4-1.5,1.7H6.6C6.6,7.1,7.2,5,10,5c2.4,0,3.4,1.6,3.4,3C13.4,10.4,11,10.8,11,12.3z" />
          <circle cx="10" cy="15" r="1" />
          <path
            d="M10,2c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S5.6,2,10,2
            M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0 L10,0z" />
        </g>
      </svg>
    </span>
    <span class="label">{label}</span>
  </button>

  <!-- the script element below is needed by the zendesk widget  -->
  <script>

  </script>
</div>

<style>
  .hidden {
    display: none;
  }

  * {
    box-sizing: border-box;
  }

  #zendesk_support {
    position: fixed;
    right: 15px;
    bottom: 10px;
    background-size: 100%;
    z-index: 2147483647;
  }

  .btn {
    box-shadow: 0px 8px 10px -5px rgb(0 0 0 / 20%), 0px 16px 24px 2px rgb(0 0 0 / 14%), 0px 6px 30px 5px rgb(0 0 0 / 12%);
    background-color: #336699 !important;
    color: #ffffff !important;
    fill: #ffffff !important;
    padding: 0.92857rem 1.57143rem;
    border-radius: 999rem;
    bottom: 0;
    font-size: 1.07143rem;
    border: none !important;
    font-weight: 700;
    box-sizing: border-box;
    margin: 0;
    min-width: 100%;
    table-layout: auto;
    white-space: nowrap !important;
    text-align: left !important;
    cursor: pointer !important;
    display: inline-block;
    max-width: 100%;
    text-transform: none;
    overflow: visible;
    outline: none;
  }

  .icon {
    margin-top: 2px;
  }

  .container {
    display: inline-block !important;
    max-width: 100%;
    vertical-align: middle;
  }

  .label {
    vertical-align: middle;
  }
  
  
  @media (min-width: 0) and (max-width: 768px) {
    .label {
      display: none;
    }
  }
  
</style>
